import { Text } from "native-base";
import React from "react";

import MobileHeader from "@/components/molecules/MobileHeader";
import Container from "@/components/organisms/Container";
import { isNativeDevice } from "@/utils/platform";

import NewAddresForm from "./components/Form";
import { NewAddresScreenProps } from "./types";

const NewAddressMobile = ({
  address,
  isSubmiting,
  isFetchingAddress,
  location,
  onBack,
  onCancel,
  onCepChange,
  onSubmit,
  onNumberChange,
}: NewAddresScreenProps) => {
  return (
    <Container
      overlapMaxHeight={!isNativeDevice}
      Header={<MobileHeader title="Novo Endereço" onBackPress={onBack} />}>
      <Text fontSize="lg" textAlign="center" py="2">
        Onde devemos entregar suas compras?
      </Text>
      <NewAddresForm
        address={address}
        isSubmiting={isSubmiting}
        isFetchingAddress={isFetchingAddress}
        location={location}
        onCancel={onCancel}
        onCepChange={onCepChange}
        onSubmit={onSubmit}
        onNumberChange={onNumberChange}
      />
    </Container>
  );
};

export default NewAddressMobile;
